// extracted by mini-css-extract-plugin
export var brand = "_b8-9";
export var compact = "_b8-6";
export var extraSmall = "_b8-7";
export var icon = "_b8-0";
export var large = "_b8-4";
export var light = "_b8-1";
export var medium = "_b8-5";
export var outline = "_b8-b";
export var primaryDark = "_b8-a";
export var primaryLight = "_b8-8";
export var primaryModern = "_b8-c";
export var success = "_b8-2";
export var successSolid = "_b8-3";